import { Link } from 'react-router-dom';
import { ChevronRight, Mail } from 'lucide-react';
import styles from './SupportPage.module.css';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import Breadcrumb from '../components/Breadcrumb';

const CONTACT_EMAIL = 'daeat.notice@gmail.com';

export default function SupportPage() {
  useDocumentMeta({ title: '고객지원', description: '다잇 이용 문의와 자주 묻는 질문' });
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <Breadcrumb current="고객지원" />

        <header className={styles.head}>
          <h1 className={styles.pageTitle}>고객지원</h1>
          <p className={styles.lead}>
            서비스 이용 중 불편한 점이나 궁금한 점을 보내주시면 운영시간 내에 순차적으로 답변드립니다.
          </p>
        </header>

        <dl className={styles.info}>
          <div className={styles.row}>
            <dt className={styles.label}>문의 이메일</dt>
            <dd className={styles.value}>
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </dd>
          </div>
          <div className={styles.row}>
            <dt className={styles.label}>운영시간</dt>
            <dd className={styles.value}>평일 09:00 ~ 18:00</dd>
          </div>
        </dl>

        <a className={styles.mailBtn} href={`mailto:${CONTACT_EMAIL}`}>
          <Mail size={18} strokeWidth={2} />
          메일로 문의하기
        </a>

        <nav className={styles.related}>
          <Link to="/terms">
            서비스 이용약관
            <ChevronRight size={16} strokeWidth={2} />
          </Link>
          <Link to="/privacy">
            개인정보처리방침
            <ChevronRight size={16} strokeWidth={2} />
          </Link>
        </nav>
      </div>
    </div>
  );
}
